var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-10 py-6",staticStyle:{"background-color":"white","height":"100%"}},[_c('InputSEPSimple')],1)}
var staticRenderFns = []

export { render, staticRenderFns }